import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ActionReducerMapBuilder } from "@reduxjs/toolkit/src/mapBuilders";
import { NoInfer } from "@reduxjs/toolkit/src/tsHelpers";
import { setUser } from "../../common/user";
import { transactionService } from "../../../services/cashier/transactions.service";
import { OrderType } from "../../../components/affiliate/Trackers";
import { setGeneralProgressHide, setGeneralProgressShow, setGeneralSnackbarState } from "../../common/ui";

export type payloadList = {
  page: number;
  perPage?: number;
  order: OrderType;
  filter: {
    search?: string | null;
    dateFrom?: string | null;
    dateTo?: string | null;
    transactionType?: string | null;
    wallet?: any | null;
  }
};

export type listItem = {
  id: number;
  username: string;
  status: string;
  type: string;
  email: string;
  createdAt: string;
  level: number;
  allSubAgents: number;
  directSubAgents: number;
  playersCount: number;
};

export type columnsItem = {
  name: string;
  type: string;
  sort: boolean;
  match?: boolean;
};

export interface ITableData {
  list: listItem[];
  columns: columnsItem[];
  startRowNum: number;
  endRowNum: number;
  totalEntries: number | string;
  totalPages: number;
}

export type transactionsSliceState = {
  list: {
    data: ITableData | null,
    error: any,
    isFetching: boolean,
  },
};

const initialState: transactionsSliceState = {
  list: {
    data: null,
    error: null,
    isFetching: false,
  },
};

export const getListData: any = createAsyncThunk(
  'cashier/transactions/getListData',
  async (payload: payloadList, { rejectWithValue, dispatch }) => {
    dispatch(setGeneralProgressShow());
    try {
      const response = await transactionService.getList(payload);
      const data = await response.json();

      if (data.hasOwnProperty('authorized') && data.authorized === false) {
        dispatch(setUser(null));
        localStorage.removeItem('user');
      }

      if (!response.ok) {
        dispatch(setGeneralProgressHide());
        return rejectWithValue(data)
      }

      dispatch(setGeneralProgressHide());

      return data;
    } catch (error) {
      dispatch(setGeneralProgressHide());
      return rejectWithValue(error)
    }
  }
);


export const transactionsSlice = createSlice({
  name: 'transactions',
  initialState: initialState,
  reducers: {
    clearListState(state) {
      state.list.error = null;
      state.list.isFetching = false;
      state.list.data = null;
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<NoInfer<transactionsSliceState>>) => {
    builder.addCase(getListData.pending, (state ) => {
      state.list.isFetching = true;
      state.list.error = null;
    });
    builder.addCase(getListData.fulfilled, (state , action) => {
      state.list.error = null;
      state.list.isFetching = false;
      state.list.data = action.payload;
    });
    builder.addCase(getListData.rejected, (state , action) => {
      state.list.isFetching = false;
      state.list.error = action.payload;
      state.list.data = null;
    });

  },
});

export const {
  clearListState,
} = transactionsSlice.actions;

export default transactionsSlice.reducer;


